import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import TextAreaInput from "Root/quiz/elements/textAreaInput/textArea";
import styles from "./question.module.scss";
const QuestionComponent = (props) => {
    const { setValue, value } = props;
    const limitReached = props.value.length === 300;
    return (_jsx("div", { className: styles.question_container, children: _jsxs("div", { className: styles.row, children: [_jsx("span", { children: "Please type your response below" }), _jsx(TextAreaInput, { maxLength: 300, value: props.value, setValue: setValue, extraClassName: "heightlarge" }), _jsxs("div", { className: `${limitReached && styles.error} ${styles.limit_line}`, children: [_jsx("small", { children: limitReached && `Limit 300 characters` }), _jsxs("small", { children: [value.length, "/", 300] })] })] }) }));
};
export default QuestionComponent;
